export default __webpack_public_path__ + "static/media/CrowdStrike.50074914.svg";